/*
 * @Author: Junchi Zhao
 * @LastEditors: Junchi Zhao
 * @Description:
 */
import Home from "@/jh/pages/home/index";
import login from "@/jh/pages/login/index";
import thirdLogin from "@/jh/pages/login/thirdLogin.vue";
import index from "@/jh/pages/index/index.vue";
import page404 from "@/jh/components/404.vue";
import demoRoutes from "@/jh/router/demoRouter";
import breedRouter from "./breed-route";
import trpInfo from "./trpInfo";
import mateInfo from "./mateInfo";
import syComp from "./syComp";
import sySheep from "./sySheep";
import tzInfo from "./tzInfo";
import categoryInfo from "./categoryInfo";
import regInfo from "./regInfo";
import cockpit from "./cockpit";
import dpInfo from "./dpInfo";
import fd from "./fd-router";
import loginRoutes from "./login";
import sysSoft from "./sysSoft";
import yuCard from "./yuCard";
import sy from "./sy";
import tag from "./tag";

export const constantRoutes = [
  {
    path: "/login",
    name: "login",
    component: login
  },
  ...loginRoutes,
  ...sy,
  {
    path: "/thirdLogin",
    name: "thirdLogin",
    component: thirdLogin
  },
  ...cockpit,
  {
    path: "/",
    name: "Home",
    redirect: "/home",
    component: Home,
    meta: {
      title: "首页",
      path: "首页"
    },
    children: [
      {
        path: "/error",
        name: "error",
        component: page404,
        meta: {
          title: "page404",
          icon: "",
          noCache: true,
          affix: false
        }
      },
      {
        path: "/home",
        name: "index",
        component: index,
        meta: {
          title: "首页",
          icon: "dashboard",
          noCache: true,
          affix: true,
          all: true
        }
      },
      ...demoRoutes,
      ...breedRouter,
      ...trpInfo,
      ...mateInfo,
      ...syComp,
      ...sySheep,
      ...tzInfo,
      ...categoryInfo,
      ...regInfo,
      ...dpInfo,
      ...fd,
      ...sysSoft,
      ...yuCard,
      ...tag,
    ]
  },
  {
    path: "*",
    name: "404",
    redirect: "/error"
  }
];
const createRouter = () =>
  new VueRouter({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465 去除路由name重复的警告 软重置
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js